
import React from 'react';

type TourHighlight = {
  name: string;
  description: string;
};

type TourHighlightsProps = {
  highlights: TourHighlight[];
};

const TourHighlights = ({ highlights }: TourHighlightsProps) => {
  return (
    <section className="mb-16">
      <h2 className="section-title-left mb-6">Tour Highlights</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {highlights.map((highlight, index) => (
          <div key={index} className="bg-neutral-tan p-6 rounded-md shadow-sm">
            <h3 className="font-playfair text-lg font-bold mb-2 flex items-baseline">
              <span className="text-2xl mr-2">🐾</span>
              <span>{highlight.name}</span>
            </h3>
            <p className="text-text/80">{highlight.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TourHighlights;
